import { render, staticRenderFns } from "./Wechat.vue?vue&type=template&id=f7d9a014&scoped=true"
import script from "./Wechat.vue?vue&type=script&lang=js"
export * from "./Wechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d9a014",
  null
  
)

export default component.exports